import { BaseView, PromiseCompletionSource } from "scene-manager";
import { PreloaderModel } from "../models/PreloaderModel";
import { PreloaderResourcesPackage } from "../resources/PreloaderResourcesPackage";
import { nameof } from "bindable-data";
import { ICanvasScaler } from "../../../../canvas/ICanvasScaler";
import { PreloaderController } from "../controllers/PreloaderController";
import { IDestroyOptions } from "@pixi/display";
import { FullscreenBackground } from "../../common/components/FullscreenBackground";
import { Sprite } from "@pixi/sprite";
import { ProgressBarSpine } from "../components/ProgressBarSpine";

export class PreloaderView extends BaseView<void> {
    private logo: Sprite;
    private progressBar: ProgressBarSpine;

    public constructor(
        private readonly preloaderResources: PreloaderResourcesPackage,
        private readonly preloaderModel: PreloaderModel,
        private readonly preloaderController: PreloaderController,
        private readonly canvasScaler: ICanvasScaler,
        private readonly fullscreenBackground: FullscreenBackground,
        viewCanBeClosed: PromiseCompletionSource<void>
    ) {
        super(viewCanBeClosed);
        this.build();
        this.layout();
        this.preloaderModel.propertyChanged.add(this.preloaderModelChangeHandler, this);
    }

    public start(): void {
        this.preloaderController.startPreloading().then(() => {
            this.operationControls.complete();
        });
    }

    private build(): void {
        const backgroundTexture = window.maxTextureSize <= 4096
            ? this.preloaderResources.assets_preloader_background_mobile_png :
            this.preloaderResources.assets_preloader_background_png;
        this.fullscreenBackground.updateImage(backgroundTexture);
        this.logo = new Sprite(this.preloaderResources.assets_preloader_logo_png);
        this.addChild(this.logo);
        this.progressBar = new ProgressBarSpine(this.preloaderResources);
        this.addChild(this.progressBar);
    }

    private layout(): void {
        const referenceWidth = this.canvasScaler.referenceWidth;
        const referenceHeight = this.canvasScaler.referenceHeight;
        this.logo.position.set((referenceWidth - this.logo.width) * 0.5, 560);
        this.progressBar.position.set((referenceWidth - this.progressBar.width) * 0.5, 1340);
    }

    private preloaderModelChangeHandler(model: PreloaderModel, property: string): void {
        switch (property) {
            case nameof(model, "loadingProgress"):
                this.progressBar.value = model.loadingProgress.value;
                console.log(`Loading progress: ${(this.progressBar.value * 100).toFixed(1)}%`);
                break;
        }
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.preloaderModel.propertyChanged.remove(this.preloaderModelChangeHandler, this);
        super.destroy(options);
    }
}
